<script lang="ts" setup>
import { stepRoutes } from '@/steps-meta/routes'

const stepsStore = useStepsStore()
const lifecycleStore = useLifecycleStore()
const requestMetaStore = useRequestMetaStore()
const options = useOptions()

function resolveLabel(label: string | ((options: OwnbitConfigurator.PluginOptions) => string)) {
  return typeof label === 'function' ? label(options) : label
}

const steps = computed(() =>
  stepRoutes
    .flatMap((route, index) => {
      const isActive =
        typeof route.meta.step.isActive === 'function'
          ? route.meta.step.isActive(route.meta.step.store, requestMetaStore)
          : route.meta.step.isActive
      if (!isActive) return []

      return {
        label: resolveLabel(route.meta.step.label),
        sublabel: resolveLabel(route.meta.step.sublabel),
        name: route.name,
        path: route.path,
        isActive: route.meta.step.isActive,
        showInHeader: route.meta.step.showInHeader,
        store: route.meta.step.store,
      }
    })
    .map((step, index) => ({
      ...step,
      index,
    })),
)

const visibleSteps = computed(() =>
  steps.value.filter(step =>
    typeof step.showInHeader === 'function'
      ? step.showInHeader(step.store, requestMetaStore)
      : step.showInHeader,
  ),
)
</script>

<template>
  <div
    data-component-stepper-header
    class="rounded border border-light-grey"
    :style="{ '--steps-count': visibleSteps.length }"
  >
    <nav>
      <ul
        class="text-s sm:grid sm:grid-cols-[repeat(var(--steps-count),_1fr)] sm:justify-between sm:text-sm"
      >
        <template v-for="{ label, sublabel, path, store, index } in visibleSteps">
          <li class="z-10 border-t first:border-t-0 focus-within:z-20 sm:border-none">
            <ActionTrigger
              @click="stepsStore.goTo(index)"
              class="h-full w-full text-left focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-green-800"
            >
              <StepperHeaderItem
                :store
                :index
                :status="
                  store.isValid && !requestMetaStore.finalized
                    ? 'complete'
                    : lifecycleStore.attemptedSubmit && !store.isValid
                      ? 'incomplete'
                      : 'initial'
                "
                :is-first="index === 0"
                :is-last="index === visibleSteps.length - 1"
                :is-current="index === stepsStore.currentStepIndex"
                :is-before-current="index < stepsStore.currentStepIndex"
                :is-after-current="index > stepsStore.currentStepIndex"
              >
                {{ label }}
                <template #sublabel>{{ sublabel }}</template>
              </StepperHeaderItem>
            </ActionTrigger>
          </li>
        </template>
        <div
          aria-hidden="true"
          class="col-start-1 col-end-[calc(var(--steps-count)_+_1)] row-span-1 row-start-1 hidden sm:block"
        ></div>
      </ul>
    </nav>
  </div>
</template>

<style lang="scss">
// [data-component-stepper] {
//   .router-link-active {
//     @apply font-medium text-blue-500;
//   }
// }
</style>
